/* eslint-disable no-param-reassign */
/* eslint-disable import/no-cycle */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Button, Tooltip } from 'crux';
import isArray from 'lodash/isArray';
import isPlainObject from 'lodash/isPlainObject';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import NListQuestions from './NListQuestions';
import TextElement from '../Components/UIElements/TextElement';
import { submitSectionQuestion } from '../redux/actions/questions'

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  button {
    margin-right: 20px;
  }
`;

const getRandomId = () => {
  return Math.floor((window.crypto.getRandomValues(new Uint32Array(1)) * 99999) + 1);
}

const updateQuestionId = (questions, id = getRandomId()) => {
  if (isArray(questions)) {
    questions.forEach(q => {
      q.question_id = `_$ureify_${q.question_id}_$ureify_${id}`;
      if (q.questions && q.questions.length > 0) {
        updateQuestionId(q.questions, id);
      }
    })
  }
}

const getQuestionsCopy = (questionsCopy) => {
  const qCopy = cloneDeep(questionsCopy);
  updateQuestionId(qCopy);
  return qCopy;
}


// This is a temporary fix, check backend for the solution.
// Problem: when page is reloaded, the backend sends an array of objects in
// questions. But when an item is added, backend sends an array of array of objects.

const getExistingItems = (questions) => {
  if (isArray(questions) && isPlainObject(questions[0])) {
    return [getQuestionsCopy(questions, getRandomId())];
  }
  return questions.map(item => {
    return getQuestionsCopy(item, getRandomId());
  })
}

const NList = ({
  listQ,
  enableAdd,
  removeListItem,
  isLoading,
}) => {
  const {
    question_description: questionDescription,
    question_text: questionText,
    original_questions: questionsCopy,
    add_button_text: addButtonText,
    add_button_tooltip: addTooltip,
    remove_button_text: removeButtonText,
    remove_button_tooltip: removeTooltip,
    question_id: questionId,
    presentation_type: presentationType,
    questions,
  } = listQ;

  const [questionsGrid, setQuestionsGrid] = useState({});
  const hasListItems = questions && questions.length > 0
  const existingListItems = hasListItems ? questions : []; 
  const isReview = presentationType === 'review';

  /**
   * This useEffect hooks takes care of the list items in the questions.
   * For the first time, when there are no list items, i.e. the questions array
   * is not present, make use of questionsCopy which is the original_questions,
   * and create the questions and display on the screen,
   * 
   * When a list item is answered, a reflexive call is made and the backend returns
   * the selected answer (question object with response filled). In this case, create
   * a list of existing items to be displayed on the screen, as well as any child questions.
   */
  useEffect(() => {
    if (hasListItems) {
      setQuestionsGrid({
        ...questionsGrid,
        [questionId]: [
          ...getExistingItems(existingListItems),
        ],
      })
    } else if(!isReview){
      setQuestionsGrid({
        ...questionsGrid,
        [questionId]: [
          [...getQuestionsCopy(questionsCopy, getRandomId())],
        ],
      })
    } 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAdd = () => {
    setQuestionsGrid({
      ...questionsGrid,
      [questionId]: [
        ...questionsGrid[questionId],
        [...getQuestionsCopy(questionsCopy, getRandomId())],
      ],
    })
  }

  if (isEmpty(questionsGrid)) {
    return null;
  }
  return (
    <>
      <TextElement text={ questionText } styleType="questions_group" />
      <TextElement text={ questionDescription } styleType="normal" />
      <div>
        <NListQuestions
          list={ questionsGrid }
          removeButtonText={ removeButtonText }
          removeTooltip={ removeTooltip }
          removeItem={ removeListItem }
          isReview={ isReview }
        />
        {
          !isLoading && enableAdd && !isReview &&
            <ButtonContainer>
              <Button
                color='green'
                label={ addButtonText }
                disabled={ false }
                type='filled'
                handleButtonClick={ handleAdd }
              />
              <Tooltip tooltipHTML={ addTooltip } />
            </ButtonContainer>
        }
      </div>
    </>
  )
}

const mapStateToProps = ({ nList, questions }) => {
  return {
    enableAdd: nList.enableAdd,
    isLoading: questions.isLoading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    removeListItem: (key, index) => {
      dispatch(submitSectionQuestion(0, {
        validate: true,       // this will force sending only answers array to backend
        removeIndex: {
          [key]: index,
        },
      }));
    },
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(NList);
